import AsyncStorage from '@react-native-async-storage/async-storage';

export default async (key = 'crm-token') => {
  const data = await AsyncStorage.getItem(key);
  if (data) {
    return JSON.parse(data);
  }
  return undefined;
};
